import type { ChartOptions } from 'chart.js';

export const crmPalette = {
  blue: '#2563EB',
  indigo: '#4F46E5',
  violet: '#8B5CF6',
  green: '#22C55E',
  amber: '#F59E0B',
  red: '#EF4444',
  slate: '#94A3B8',
  teal: '#14B8A6',
};

export const crmGridColor = 'rgba(148, 163, 184, 0.22)';

export const crmChartOptions: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 16,
        color: '#475569',
        font: { size: 12, weight: 500 },
      },
    },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.96)',
      titleColor: '#fff',
      bodyColor: '#E2E8F0',
      padding: 12,
      displayColors: false,
      cornerRadius: 10,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: '#64748B', font: { size: 11 } },
    },
    y: {
      grid: { color: crmGridColor },
      ticks: {
        color: '#64748B',
        font: { size: 11 },
      },
    },
  },
};

export const crmDoughnutOptions: ChartOptions<'doughnut'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 16,
        color: '#475569',
        font: { size: 12, weight: 500 },
      },
    },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.96)',
      titleColor: '#fff',
      bodyColor: '#E2E8F0',
      padding: 12,
      displayColors: false,
      cornerRadius: 10,
    },
  },
  cutout: '68%',
};
